<template>
  <div class="feed-card messagerie-item feed__infos-block beneficiary-message">
    <div class="d-flex position-relative">
      <span class="v-line"></span>

      <div class="content">
        <h3 v-html="userActivity.title_html"></h3>
        {{ userActivity.data.message }}

        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>

</template>

<script>
  import TimeInfos from '@components/utils/TimeInfos.vue';

  export default {
    props: {
      userActivity: Object
    },
    components: {
      TimeInfos
    },
  };
</script>
